let cached = null;

export async function detectGeo() {
  if (cached) return cached;
  let country = "";
  try {
    const res = await fetch("/cdn-cgi/trace", { cache: "no-store" });
    if (res.ok) {
      const text = await res.text();
      const m = text.match(/loc=([A-Z]{2})/);
      country = m ? m[1] : "";
    }
  } catch {
    /* not behind Cloudflare */
  }
  const isIndia = country === "IN";
  cached = {
    country: country || "UNKNOWN",
    currency: isIndia ? "INR" : "USD",
    gateway: isIndia ? "razorpay" : "stripe",
    symbol: isIndia ? "₹" : "US$",
  };
  return cached;
}
